<template>
    <v-form>
        <v-row>
            <v-col cols="12">
                <v-text-field
                    label="Code"
                    v-model="form.code"
                    dense
                    outlined
                    hide-details="auto"
                    clearable
                >
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <PDatePicker
                    v-model="form.from"
                    outlined
                    dense
                    clearable
                    hide
                    label="From">
                </PDatePicker>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <PDatePicker
                    v-model="form.to"
                    outlined
                    clearable
                    dense
                    hide
                    label="To">
                </PDatePicker>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-autocomplete
                    v-model="form.created_by_id"
                    outlined
                    dense
                    hide-details="auto"
                    label="Created By"
                    clearable
                    @update:search-input="searchUsers"
                    item-text="name"
                    item-value="id"
                    :items="users"
                >
                </v-autocomplete>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-select
                    label="State"
                    outlined
                    dense
                    hide-details="auto"
                    :items="states"
                    v-model="form.state"
                    clearable
                >
                </v-select>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import PDatePicker from "./../common/PDatePicker.vue"
import creditNote from "./../../services/purchase/creditNote"
import userAPI from './../../services/purchase/user'

export default {
    name: "CreditNoteListSearch",
    components: {
        PDatePicker
    },
    data() {
        return {
            form : {
                code: "",
                from: null,
                to: null,
                state: null,
                created_by_id: null
            },
            states : [],
            users: [],
            usersLoading: false
        }
    },
    computed: {
        ...mapGetters({
            params: "purchase/creditNote/params"
        })
    },
    methods: {
        ...mapActions({
            updateParams: "purchase/creditNote/updateParams"

        }),
        submit() {
            this.updateParams(this.form)
        },
        searchUsers(query) {
            this.usersLoading = true;
            userAPI.search(query).then(response => {
                this.users = Array.from(new Set([...this.users, ...response.data]));
            }).finally(() => {
                this.usersLoading = false;
            })
        }
    },
      created() {
        this.form = {...this.params}
        creditNote.states().then(response => this.states = response.data);
    }
}
</script>

<style>

</style>